import { Component, input } from '@angular/core';
import { AdvertViewModel } from '@models/advert/advert';
import { TranslateModule } from '@ngx-translate/core';
import { NumeralPipe } from '../../../../pipes/numeral.pipe';

@Component({
    selector: 'apartment-sale-stats',
    templateUrl: './apartment-sale-stats.component.html',
    imports: [TranslateModule, NumeralPipe]
})
export class ApartmentSaleStatsComponent {
    readonly advert = input<AdvertViewModel>(undefined);
}
